module.exports = __webpack_public_path__ + "img/7.4d6b00f2.png";